import React, { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

// Draggable before/after comparison slider
export default function CompareSlider({ before, after }) {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const setFromClientX = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let pct = ((clientX - rect.left) / rect.width) * 100;
    pct = Math.max(0, Math.min(100, pct));
    setPos(pct);
  }, []);

  const onDown = () => (dragging.current = true);
  const onUp = () => (dragging.current = false);
  const onMove = (e) => {
    if (!dragging.current) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    setFromClientX(clientX);
  };

  return (
    <div
      ref={containerRef}
      className="relative w-full aspect-[4/3] overflow-hidden select-none bg-[#161616] cursor-ew-resize"
      onMouseDown={(e) => {
        onDown();
        setFromClientX(e.clientX);
      }}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onMouseMove={onMove}
      onTouchStart={onDown}
      onTouchEnd={onUp}
      onTouchMove={onMove}
    >
      {/* After (full) */}
      <img src={after} alt="After" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <span className="absolute top-3 right-3 bg-[#0C0C0C]/70 text-[#C6A15B] text-[10px] tracking-[0.2em] uppercase px-3 py-1">
        After
      </span>

      {/* Before (clipped) */}
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt="Before"
          className="absolute inset-0 h-full object-cover"
          style={{ width: containerRef.current ? containerRef.current.offsetWidth : "100%" }}
          draggable={false}
        />
        <span className="absolute top-3 left-3 bg-[#0C0C0C]/70 text-[#EDE7DA] text-[10px] tracking-[0.2em] uppercase px-3 py-1">
          Before
        </span>
      </div>

      {/* Handle */}
      <div className="absolute top-0 bottom-0 w-[2px] bg-[#C6A15B]" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-[#C6A15B] flex items-center justify-center shadow-lg">
          <MoveHorizontal size={18} className="text-[#0C0C0C]" />
        </div>
      </div>
    </div>
  );
}
